import React from "react";
import { FormattedMessage } from "react-intl";

import { SectionHeader } from "../../../components/sectionHeader/SectionHeader";
import { LogoUpload } from "../../../components/logoUpload/LogoUpload";
import { useDispatch, useSelector } from "react-redux";
import { getBrandingDraftLogo, getBrandingLogo } from "../branding.selectors";
import _ from "lodash";
import { changeLogoToSave } from "../branding.actions";

export const Logo = React.memo(() => {
  const savedLogo = useSelector(getBrandingLogo);
  const draftLogo = useSelector(getBrandingDraftLogo);
  const logo = draftLogo || _.isNil(draftLogo) ? draftLogo : savedLogo;
  const dispatch = useDispatch();
  const uploadSuccessHandler = (value) => dispatch(changeLogoToSave(value));

  return (
    <fieldset className="branding__logo col-md-5">
      <SectionHeader title={<FormattedMessage id={"add_logo"} />} />
      <LogoUpload logo={logo} onUploadSuccess={uploadSuccessHandler} />
    </fieldset>
  );
});
